if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');

        if (this.classList.contains('product-media-modal--peek')) {
          // Natulim (sep-2026): aca TODAS las fotos quedan visibles en fila
          // (ver ".product-media-modal--peek" en section-main-product.css),
          // asi que hay que llevar el scroll al borde izquierdo de la foto
          // activa, no centrarla (el calculo de mas abajo asume una sola
          // foto con overflow:auto, no un carrusel).
          const activeRect = activeMedia.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          container.scrollLeft += activeRect.left - containerRect.left;
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
